export default function useLocale({ matchPathName }) {
  const locale =
    typeof window === 'object' && location.pathname.includes(matchPathName) ? 'en' : 'es';
  const enLocale = locale === 'en';

  return { enLocale: !enLocale };
}
